import React from 'react';
import { ListingCard } from '../../components';

import css from './FavoritesPage.module.css';

const FavoritesCardSection = props => {
  const { listings, cardRenderSizes } = props;
  return (
    <div className={css.listingCards}>
      {listings.map(l => (
        <ListingCard
          className={css.listingCard}
          key={l.id.uuid}
          listing={l}
          renderSizes={cardRenderSizes(false)}
          isFavorites
          setActiveListing={() => {}}
        />
      ))}
    </div>
  );
};

export default FavoritesCardSection;
